import React from 'react'
import ContactLayout from '../components/ui/layout/ContactLayout'
import { Helmet } from 'react-helmet'

const Contact = () => {
    return (
        <>
         <Helmet>
                    <title>Contact - Luxlife Miami Real Estate LLC</title>
                </Helmet>
            <ContactLayout />
        </>
    )
}

export default Contact